import { useEffect, useState } from 'react';
import { Download, Loader2, Receipt } from 'lucide-react';
import UctenkaHtml from '../UctenkaHtml';

/**
 * Účtenka vybrané objednávky — třetí sloupec detailu v Objednávkách
 * (na mobilu v modalu z detailu). Stejná šablona jako tisk, stránka
 * objednávky i PDF; jen ke čtení, s tlačítkem na stažení PDF.
 *
 * @param {number} id        objednávka
 * @param {number} sirka     kolik místa účtenka má (px)
 * @param {number} [obnova]  změna = načíst znovu (živé Objednávky)
 */
export default function UctenkaObjednavky({ id, sirka = 288, obnova = 0, isDark }) {
    const [data, setData] = useState(null);
    const [chyba, setChyba] = useState(null);

    useEffect(() => {
        let platne = true;
        setChyba(null);
        fetch(`/api/objednavky/${id}/uctenka`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
            .then(r => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
            .then(d => { if (platne) setData(d); })
            .catch(e => { if (platne) setChyba(e?.message || 'Účtenka se nenačetla.'); });
        return () => { platne = false; };
    }, [id, obnova]);

    const muted = 'var(--text-secondary)';

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <div className="flex items-center" style={{ gap: 8 }}>
                <Receipt size={15} style={{ color: muted }} />
                <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', color: muted }}>Účtenka</span>
                <span style={{ marginLeft: 'auto', fontSize: 12, color: muted, fontVariantNumeric: 'tabular-nums' }}>
                    {data?.doklad?.nahled ? 'náhled · účet otevřený' : data?.doklad?.cislo ? `č. ${data.doklad.cislo}` : ''}
                </span>
            </div>

            {chyba && <p className="text-sm" style={{ color: '#F87171', margin: 0 }}>Účtenka se nenačetla: {chyba}</p>}
            {!data && !chyba && (
                <div className="flex justify-center" style={{ padding: 24 }}>
                    <Loader2 size={18} className="animate-spin" style={{ color: muted }} />
                </div>
            )}
            {data?.html && <UctenkaHtml html={data.html} sirka={360} zobrazit={sirka} />}

            {data?.html && !data.doklad?.nahled && (
                <a href={`/api/objednavky/${id}/uctenka.pdf`} className="flex items-center justify-center rounded-lg"
                    style={{
                        gap: 8, minHeight: 40, fontSize: 13, fontWeight: 600, textDecoration: 'none', color: 'var(--text-primary)',
                        border: `1px solid ${isDark ? 'rgba(255,255,255,0.12)' : 'var(--border-default)'}`,
                    }}>
                    <Download size={15} /> Stáhnout PDF
                </a>
            )}
        </div>
    );
}
